import React from 'react'
import styled from 'styled-components'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { IconParkName } from 'packages/components/GrowpIcon/types'
import { modeToColors, modeToIconName, modeToText } from './utils'
import { ReviewResultEnum } from 'packages/sdks-next/growp'
import { precisionFormat } from 'packages/utils'
import { useAnswersManagement } from './context'

/**
 * 判题结果标签
 * @param param - 参数
 * @param param.mode - 模式【正确|半对|错误】
 * @param param.score - 得分
 * @returns React.ReactNode
 */
export const TrueOrFalseTag: React.FC<{
  mode?: ReviewResultEnum | null
  score?: string | null
}> = ({ score, mode }) => {
  const { showScore } = useAnswersManagement()
  const colors = modeToColors[mode || ReviewResultEnum.Wrong]
  return (
    <Wrapper $colors={colors}>
      {mode ? (
        <GrowpIcon
          name={modeToIconName[mode] as IconParkName}
          size={12}
          color={colors[0]}
          text={modeToText[mode]}
        />
      ) : (
        <div
          style={{
            fontSize: '12px',
          }}
        >
          未作答
        </div>
      )}
      {showScore ? (
        <div
          style={{
            marginLeft: '8px',
          }}
        >
          {precisionFormat(score) || '0'}分
        </div>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $colors: string[] }>`
  /* min-width: 84px; */
  height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  background-color: ${(props) => props.$colors[1]};
  border: 1px solid ${(props) => props.$colors[2]};
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.$colors[0]};
`
